export interface SectorMarketRegion {
  mr_code: string;
  mr_id: number;
  mr_name: string;
  mr_region: string;
  version_number: string | null;
}

export interface BranchNames {
  mb_code: string;
  mb_id: number;
  mb_name: string;
  mb_region: string;
  mb_region_id: number;
  next_sector_id?: number;
}

export interface DistrictNames {
  city: CityNames;
  d_id: number;
  district_name: string;
  sector_id: number | null;
  new_name?: string;
  is_checked?: boolean;
}

export interface DistrictCoefficient {
  id: number;
  district_id: number;
  coefficient: string;
}

export interface CityNames {
  ct_id: number;
  ct_mccode: string;
  ct_name: string;
  ct_timeshift: number;
  current_time: string;
  market_branch: number;
  utc_shift: number;
}

export interface SectorNames {
  sector_id: number;
  sector_number_str: string;
  sector_number_sort?: number;
  is_visible: number;
}

export enum SectorRole {
  MT = 'm_t',
  GRRS = 'grrs'
}

export interface SectorHead {
  employee: {
    full_name: string;
    phone: number | string;
  };
  login: string;
  u_id: number;
}

export interface Sectors {
  count: number;
  results: Sector[];
}

export interface Sector {
  address: string;
  changed_by: number;
  city_name: string;
  city_type: string;
  country: string;
  create_date: string | null;
  created_by_user: string;
  districts: any;
  house_building: string;
  house_number: string;
  is_visible: number;
  latitude: string;
  longitude: string;
  market_code: number;
  market_branch: any;
  office_number: string;
  rec_actual_date: string;
  rec_create_date: string;
  region_name: string;
  s_id: number;
  sector_role: SectorRole;
  sector_head: SectorHead;
  sector_number_str: string;
  street_name: string;
  street_type: string;
  update_date: string | null;
  updated_by_user: string | null;
  version_number: string;
  state?: boolean | string | null;
  sector_id?: number | null;
  partnership_id?: number;
}

export const SECTORS_PATHS = {
  sectors: 'sectors',
  sectors_create: 'sectors/create',
  monitoring: 'monitoring/sectors',
  sectors_edit: 'sectors/:sector_id',
};
